module.exports = __webpack_public_path__ + "static/img/5009_phase_function_Paper_PointsHejduk_Prediction.59dc7a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5009_phase_function_Paper_PointsHejduk_Prediction.png
// module id = cnFs
// module chunks = 0